module.exports = __webpack_public_path__ + "img/PowerPointIcon256x256.b764ef4a.png";